import { defineMessages } from 'react-intl';

import {
  INVALID_PHONE_VERIFICATION_CODE,
  PHONE_VERIFICATION_REQUEST_EXPIRED,
  TOO_MANY_ATTEMPTS,
  WRONG_CODE_PROVIDED_TOO_MANY_TIMES,
} from './useCheckPhoneNumberVerificationCode.ts';
import { PHONE_NUMBER_ALREADY_USED } from './useVerifyPhoneNumber.ts';

export const errorMessages = defineMessages({
  [PHONE_VERIFICATION_REQUEST_EXPIRED]: {
    defaultMessage: 'The phone verification request has expired. Please retry.',
  },
  [INVALID_PHONE_VERIFICATION_CODE]: {
    defaultMessage: 'Invalid verification code. Please retry.',
  },
  [WRONG_CODE_PROVIDED_TOO_MANY_TIMES]: {
    defaultMessage: 'Wrong code provided too many times. Please retry.',
  },
  [PHONE_NUMBER_ALREADY_USED]: {
    defaultMessage: 'This phone number is already used by another user.',
  },
  [TOO_MANY_ATTEMPTS]: {
    defaultMessage:
      'You have made too many attempts. Please try again in an hour.',
  },
});

export const messages = defineMessages({
  title: {
    defaultMessage: 'To access this page, please verify your phone number',
  },
});
